/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExchangePlaidTokenRequest
 */
export interface ExchangePlaidTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof ExchangePlaidTokenRequest
     */
    plaidPublicToken: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExchangePlaidTokenRequest
     */
    isDefault: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExchangePlaidTokenRequest
     */
    acceptedTerms: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExchangePlaidTokenRequest
     */
    termsVersion: string;
    /**
     * 
     * @type {any}
     * @memberof ExchangePlaidTokenRequest
     */
    termsSnapshot: any | null;
}

/**
 * Check if a given object implements the ExchangePlaidTokenRequest interface.
 */
export function instanceOfExchangePlaidTokenRequest(value: object): value is ExchangePlaidTokenRequest {
    if (!('plaidPublicToken' in value) || value['plaidPublicToken'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    if (!('acceptedTerms' in value) || value['acceptedTerms'] === undefined) return false;
    if (!('termsVersion' in value) || value['termsVersion'] === undefined) return false;
    if (!('termsSnapshot' in value) || value['termsSnapshot'] === undefined) return false;
    return true;
}

export function ExchangePlaidTokenRequestFromJSON(json: any): ExchangePlaidTokenRequest {
    return ExchangePlaidTokenRequestFromJSONTyped(json, false);
}

export function ExchangePlaidTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangePlaidTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'plaidPublicToken': json['plaidPublicToken'],
        'isDefault': json['isDefault'],
        'acceptedTerms': json['acceptedTerms'],
        'termsVersion': json['termsVersion'],
        'termsSnapshot': json['termsSnapshot'],
    };
}

export function ExchangePlaidTokenRequestToJSON(json: any): ExchangePlaidTokenRequest {
    return ExchangePlaidTokenRequestToJSONTyped(json, false);
}

export function ExchangePlaidTokenRequestToJSONTyped(value?: ExchangePlaidTokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plaidPublicToken': value['plaidPublicToken'],
        'isDefault': value['isDefault'],
        'acceptedTerms': value['acceptedTerms'],
        'termsVersion': value['termsVersion'],
        'termsSnapshot': value['termsSnapshot'],
    };
}

